import { render, staticRenderFns } from "./EditLocalizationCard.vue?vue&type=template&id=6eb26d04&"
import script from "./EditLocalizationCard.vue?vue&type=script&lang=js&"
export * from "./EditLocalizationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports